/**
 * @generated SignedSource<<2f019ed29e69afda25d1e7a7f6c38c78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableHeader_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_refactor_user">;
  readonly " $fragmentType": "PdpRespUnavailableHeader_user";
};
export type PdpRespUnavailableHeader_user$key = {
  readonly " $data"?: PdpRespUnavailableHeader_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableHeader_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableHeader_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_refactor_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a21438f14042ddfe0c049ea11d3b94e2";

export default node;
